// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"6a1fc56f","787":"984673df","836":"a34646b4","860":"3ba475c8"}[chunkId] + ".chunk.js";
};